module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-dashboard-header"
  }, [_c('div', {
    staticClass: "dashboard-toggles"
  }, [_c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('md-switch', {
    attrs: {
      "id": "showMode",
      "name": "showMode"
    },
    on: {
      "change": _vm.toggleShowMode
    },
    model: {
      value: (_vm.localShowMode),
      callback: function($$v) {
        _vm.localShowMode = $$v
      },
      expression: "localShowMode"
    }
  }, [_vm._v("Dark Mode")])], 1)])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent ql-dashboard-header"
  }, [_c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), (_vm.isActivePay) ? _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Collaborator")]) : _c('span', {
    staticClass: "ql-dashboard-role"
  }, [_vm._v("Observer")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c93a18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/dashboard/header.vue
// module id = 648
// module chunks = 2